import React, { useState, useEffect, Fragment } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { CourceClinicList } from '../uiParts/cource_clinics/CourceClinicList';

const CourceClinics = (props) => {
  const [loading, setLoading] = useState(true);
  const [courceClinics, setCourceClinics] = useState([]);
  const [options, setOptions] = useState([]);
  const [clinics, setClinics] = useState([]);
  const { cm, cource } = props;
  // 初期設定データセット
  useEffect(() => {
    console.log("CourceClinic First Start");
    var data = { params: {cource_id: cource}};
    axios.get(`/api/v1/cource_clinics`, data)
    .then(resp => {
      console.log("success");
      console.log(resp);
      setCourceClinics(resp.data.cource_clinics);
      setOptions(resp.data.options);
      setClinics(resp.data.clinics);
    })
    .catch(e => {
      console.log("error");
      console.log(e.response);
    })
    .finally(() => {
      setLoading(false);
    });
  }, []);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const upsertCourceClinic = async (data) => {
    console.log("upsertCourceClinic Start");
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.post(`/api/v1/cource_clinics_upsert`, data)
                  .then(resp => {
                    console.log("upsert success");
                    console.log(resp.data);
                    setCourceClinics(resp.data.cource_clinics);
                    setOptions(resp.data.options);
                    setClinics(resp.data.clinics);
                    notify("success", "CourceClinics successfully done!");
                  })
                  .catch(e => {
                    console.log("upsert error");
                    console.log(e.response);
                    notify("error", "CourceClinics Error!");
                  })
                  .finally(() => {
                    setLoading(false);
                  });
    return res;
  }

  const onClickUpsertSubmit = (id) => {
    console.log("onClickUpsertSubmit Start");
    setLoading(true);
    var data = { cource_id: cource };
    upsertCourceClinic(data);
  }

  return (
    <>
      {loading ?
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        :
        <Fragment>
          <div className="mb-1 text-end">
            <button onClick={() => onClickUpsertSubmit(cource)} className="btn btn-success" title="Upsert">
              <i className="fas fa-sync-alt" /> 一括医療機関連携
            </button>
          </div>
          <div className="text-end">
            <p className="badge bg-light text-dark">医療機関マスタ件数（{clinics.length}件）</p>
          </div>
          <p className="badge bg-light text-dark">設定件数（{courceClinics.length}件）</p>
          <CourceClinicList options={options} items={courceClinics} />
        </Fragment>
      }
    </>
  );
};

export default CourceClinics;
